

<form class="form" (ngSubmit)="onSubmit()">
  <input type="text" name="title"   placeholder="Add todo..">

  <input type="submit" value="submit" class="btn">
</form>